import { render, staticRenderFns } from "./Sedes.vue?vue&type=template&id=e91e4024"
import script from "./Sedes.vue?vue&type=script&lang=js"
export * from "./Sedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports